import { useState, useEffect } from 'react';
import { getAnnouncements, createAnnouncement, updateAnnouncement, deleteAnnouncement } from '../services/api';

export default function Announcements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ message: '', target: 'both', bg_color: '#FF5722', text_color: '#FFFFFF', is_active: true });

  const load = async () => {
    try {
      const data = await getAnnouncements();
      setItems(data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editItem) {
        await updateAnnouncement(editItem.id, form);
      } else {
        await createAnnouncement(form);
      }
      setShowForm(false);
      setEditItem(null);
      setForm({ message: '', target: 'both', bg_color: '#FF5722', text_color: '#FFFFFF', is_active: true });
      load();
    } catch (err) { alert('Error: ' + err.message); }
  };

  const handleEdit = (item) => {
    setEditItem(item);
    setForm({ message: item.message, target: item.target, bg_color: item.bg_color, text_color: item.text_color, is_active: item.is_active });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this announcement?')) return;
    await deleteAnnouncement(id);
    load();
  };

  const handleToggle = async (item) => {
    await updateAnnouncement(item.id, { is_active: !item.is_active });
    load();
  };

  if (loading) return <div className="page"><p>Loading...</p></div>;

  return (
    <div className="page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>📢 Announcements</h2>
        <button className="btn-primary" onClick={() => { setShowForm(true); setEditItem(null); setForm({ message: '', target: 'both', bg_color: '#FF5722', text_color: '#FFFFFF', is_active: true }); }}>
          + New Announcement
        </button>
      </div>

      <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
        Scrolling banner shown at the top of customer and worker apps. Use for downtime notices, offers, or urgent messages.
      </p>

      {showForm && (
        <div style={{ background: '#f9f9f9', padding: 20, borderRadius: 12, marginBottom: 20, border: '1px solid #eee' }}>
          <h3>{editItem ? 'Edit Announcement' : 'New Announcement'}</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontWeight: 600, fontSize: 13 }}>Message *</label>
              <textarea
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                placeholder="e.g., Server maintenance tonight 10PM-12AM. Bookings may be delayed."
                required
                rows={3}
                style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #ddd', marginTop: 4 }}
              />
            </div>
            <div style={{ display: 'flex', gap: 16, marginBottom: 12, flexWrap: 'wrap' }}>
              <div>
                <label style={{ fontWeight: 600, fontSize: 13 }}>Target</label>
                <select value={form.target} onChange={(e) => setForm({ ...form, target: e.target.value })}
                  style={{ display: 'block', padding: 8, borderRadius: 8, border: '1px solid #ddd', marginTop: 4 }}>
                  <option value="both">Both Apps</option>
                  <option value="customer">Customer Only</option>
                  <option value="worker">Worker Only</option>
                </select>
              </div>
              <div>
                <label style={{ fontWeight: 600, fontSize: 13 }}>Background Color</label>
                <input type="color" value={form.bg_color} onChange={(e) => setForm({ ...form, bg_color: e.target.value })}
                  style={{ display: 'block', marginTop: 4, width: 50, height: 35, border: 'none', cursor: 'pointer' }} />
              </div>
              <div>
                <label style={{ fontWeight: 600, fontSize: 13 }}>Text Color</label>
                <input type="color" value={form.text_color} onChange={(e) => setForm({ ...form, text_color: e.target.value })}
                  style={{ display: 'block', marginTop: 4, width: 50, height: 35, border: 'none', cursor: 'pointer' }} />
              </div>
            </div>
            {/* Preview */}
            <div style={{ background: form.bg_color, color: form.text_color, padding: '8px 12px', borderRadius: 8, marginBottom: 12, fontSize: 13, fontWeight: 600 }}>
              📢 {form.message || 'Preview will appear here...'}
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button type="submit" className="btn-primary">{editItem ? 'Update' : 'Create'}</button>
              <button type="button" className="btn-secondary" onClick={() => { setShowForm(false); setEditItem(null); }}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      {items.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#999', padding: 40 }}>No announcements yet. Create one to show a scrolling banner in the apps.</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Message</th>
              <th>Target</th>
              <th>Preview</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.message}</td>
                <td><span className="badge">{item.target}</span></td>
                <td>
                  <div style={{ background: item.bg_color, color: item.text_color, padding: '4px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, display: 'inline-block' }}>
                    📢 {item.message.substring(0, 30)}{item.message.length > 30 ? '...' : ''}
                  </div>
                </td>
                <td>
                  <button onClick={() => handleToggle(item)}
                    style={{ background: item.is_active ? '#4CAF50' : '#ccc', color: '#fff', border: 'none', borderRadius: 12, padding: '4px 10px', fontSize: 11, cursor: 'pointer' }}>
                    {item.is_active ? 'Active' : 'Inactive'}
                  </button>
                </td>
                <td>
                  <button onClick={() => handleEdit(item)} style={{ marginRight: 6, cursor: 'pointer', border: 'none', background: 'none', fontSize: 16 }}>✏️</button>
                  <button onClick={() => handleDelete(item.id)} style={{ cursor: 'pointer', border: 'none', background: 'none', fontSize: 16 }}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
